<template>
  <div
    :class="{ ['rt-search-clearable']: clearable }"
    class="rt-search"
  >
    <el-input
      v-if="showSearch"
      ref="input"
      v-model="currentValue"
      :class="[
        'rt-input' + `-${size}`,
        `rt-search-${type}`,
        'border-' + `${borderColor}`,
        'search-icon-bg-color-' + `${searchIconBgColor}`,
        { border, 'icon-position-right': iconPosition === 'right','is-focus':isFocus }
      ]"
      v-bind="$attrs"
      :placeholder="placeholder"
      @keyup.enter.native="enterHandler"
      @input="inputHandler"
      @mouseenter.native="hovering = true"
      @mouseleave.native="hovering = false"
      @focus="focusHandler"
      @blur="blurHandler"
    >
      <!-- filterable取消下拉选项搜索功能 -->
      <el-select
        v-if="searchCondition.length>0"
        slot="prepend"
        v-model="currentType"
        placeholder="请选择"
        v-bind="$attrs"
        @change="changeSelect"
        v-on="$listeners"
        @visible-change="visibleSelect"
      >
        <el-option
          v-for="(item, index) in searchCondition"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <rt-icon
        v-if="iconPosition === 'right'"
        slot="suffix"
        :size="iconSize"
        :name="searchIconName"
        @click="onSearch"
      />
      <rt-icon
        v-else
        slot="prefix"
        :size="iconSize"
        :name="searchIconName"
        @click="onSearch"
      />
      <rt-icon
        v-if="clearable"
        v-show="isClearButtonVisible"
        slot="suffix"
        name="rt-base-circle-close-filled"
        @click="clearValue"
      ></rt-icon>
    </el-input>

    <div
      v-if="more"
      :class="`font-weight-${moreFontWeight}`"
      class="rt-search-more"
      @click="onMore"
    >
      <rt-button
        :suffix-icon="suffixIcon"
        type="plain"
        text
      >
        {{ $tx('更多筛选', 'xpc.search.more') }}
      </rt-button>
    </div>
  </div>
</template>

<script>
import { store } from '../table/store';
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton';
import config from '../../config';
export default {
  name: 'RtSearch',
  components: {
    RtIcon,
    RtButton
  },
  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default () {
        return this.$tx('搜索', 'xpc.search.search');
      }
    },
    /**
     * @public 是否支持清空
     */
    clearable: {
      type: Boolean,
      default: true
    },
    more: {
      type: Boolean,
      default: true
    },
    moreFontWeight: {
      type: String,
      default: 'primary'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    /**
     * @public 搜索按钮是否在右边
     */
    iconPosition: {
      type: String,
      default: 'left'
    },
    /**
     * @public 搜索框尺寸
     */
    size: {
      type: String,
      default: 'medium'
    },
    /**
     * @public 全局配置搜索框模式
     */
    type: {
      type: String,
      default: function () {
        return config.get('search.type');
      }
    },
    /**
     * @public 边框粗细，设置了为2px，不设置默认1px
     */
    border: {
      type: Boolean,
      default: false
    },
    /**
     * @public 搜索图标
     */
    searchIconName: {
      type: String,
      default: 'rt-base-lookup'
    },
    /**
     * @public 搜索图标背景
     */
    searchIconBgColor: {
      type: String,
      default: 'base'
    },
    /**
     * @public 边框颜色
     */
    borderColor: {
      type: String,
      default: 'base'
    },
    // 下拉选项值
    selectValue: {
      type: String,
      default: ''
    },
    // 下拉选项
    searchCondition: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      state: store.state,
      /**
       * @private 搜索框输入值
       */
      currentValue: this.value || '',
      moreVisible: false,
      /**
       * @private 清空图标是否显示
       */
      isClearButtonVisible: false,
      /**
       * @private 鼠标是否在元素内
       */
      hovering: false,
      /**
       * @private 初始下拉选择的值
       */
      currentType: this.selectValue,
      isFocus: false

    };
  },
  computed: {
    suffixIcon () {
      return this.moreVisible ? 'rt-base-arrowup2' : 'rt-base-arrowdown2';
    },
    iconDirector () {
      return {
        'has-more': this.moreVisible
      };
    },
    /**
     * @private 搜索框不同尺寸下的图标尺寸
     */
    iconSize () {
      if (this.size === 'mini') {
        return 14;
      } else {
        return 18;
      }
    }
  },
  watch: {
    value (newVal) {
      this.currentValue = newVal;
      this.judgeClearButtonVisible();
    },
    hovering () {
      this.judgeClearButtonVisible();
    }
  },
  methods: {
    /**
     * @private 判断清空按钮显隐
     * hovering为true：有值时，清空按钮显示；变为空，不显示
     * hovering为false：清空按钮不显示
     */
    judgeClearButtonVisible () {
      if (this.hovering && this.currentValue) {
        this.isClearButtonVisible = true;
      } else {
        this.isClearButtonVisible = false;
      }
    },
    clearValue () {
      this.currentValue = '';
      this.isClearButtonVisible = false;
      this.inputHandler('')
      this.$emit('clear', this.currentValue);
    },
    enterHandler () {
      this.onSearch();
    },
    inputHandler (value) {
      this.$emit('input', value);
    },
    onSearch () {
      this.$emit('on-search', this.currentValue);
    },
    changeSelect () {
      this.$emit('on-selected-change', this.currentType)
    },
    // 下拉框隐藏就让input聚焦
    visibleSelect (val) {
      if (val === false) {
        this.$nextTick(() => {
          this.$refs[`input`].focus()
        })
      }
    },
    onMore () {
      this.moreVisible = !this.moreVisible;
      const rtHeader = this.$parent.$parent;
      if (rtHeader && rtHeader.$options.name === 'RtHeader') {
        if (this.moreVisible) {
          rtHeader.showMore();
        } else {
          rtHeader.hideMore();
        }
      }
      this.$emit('moreClick', this.moreVisible);
    },
    focusHandler (e) {
      this.isFocus = true;
      this.$emit('focus', e);
    },
    blurHandler (e) {
      this.isFocus = false;
      this.$emit('blur', e);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtSearch.vue?38ea90fc